a.item.display.files = (function(){
	var my = {
		popup:function(o){
			var o = o || {};
			var iid = o.iid || null;
			var f_close = o.close || function(){};
			var token = a.popup.create({
				slideFrom:'fromleft',
				title:'Files',
				css_class:'',
				ready:function(token){
					tpl.run({
						tpl:'/tpl/item/display/files/page.ejs?v='+v,
						data:{},
						cb:function(c){
							$('#popupid_'+token+'>.ic').empty().append(c).ready(function(){
								// Init uploader button
								my.initUploader(iid,token,function(){
									// Reload files
									my.loadFiles(iid,token,f_close);
								});
								// Load files
								my.loadFiles(iid,token,f_close);
							});
						}
					});
				},
				close:function(){
					f_close();
				}
			});
		},
		loadFiles:function(iid,token,f_close){
			var win = $('#popupid_'+token);
			$.ajax({
				type:'GET',
				url:'/api/item/file/file/list/',
				data:{
					iid:iid,
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						tpl.run({
							tpl:'/tpl/item/display/files/list.ejs?v='+v,
							data:result,
							cb:function(c){
								$('div[data-area="filelist"]',win).empty().append(c).ready(function(){

								});
							}
						});
					}
					else {
						a.s.growl.create('Error','Unable to perform operation',{});
					}
				}
			});
		},
		initUploader:function(iid,token,cb){
			var uploaderid = a.shared.createToken();
			if (a.s.ac.allow('content','item')) {
				$('#popupid_'+token+' .popupwinbar>.action').append('<form name="upload"><label for="'+uploaderid+'"></label></form>').ready(function(){
					$('#popupid_'+token+' .popupwinbar>.action>form>label').append('<i class="fal fa-plus"></i>');
					$('#popupid_'+token+' .popupwinbar>.action>form>label').append('<input id="'+uploaderid+'" type="file" name="file[]" style="display:none;" multiple/>').ready(function(){
						$('#popupid_'+token+' .popupwinbar>.action>form>label>input[type="file"]').change(function(){
							my.uploadFiles(iid,token,uploaderid,cb);
						});
					});
				});
			}
		},
		uploadFiles:function(iid,token,uploaderid,cb){
			var fd = new FormData();
			var files = $('#'+uploaderid)[0].files;
			$(files).each(function(i,file){
				my.uploadFile(file,iid,function(is_done){
					if (is_done) {
						cb();
					}
				});
			});
		},
		uploadFile:function(file,iid,cb_done){
			// Create unique id
			var uid = 'fileupload_'+a.s.createToken();
			// Add to upload status
			my.addUploadStatus(file,uid,function(){
				// Add data
				var data = new FormData();
				data.append('token',localStorage.getItem('token'));
				data.append('accountname',localStorage.getItem('accountname'));
				data.append('saveasattachment',1);
				data.append('iid',iid);
				data.append('file',file);
				// Define elements in upload record
				var upload_record =  $('#'+uid);
				var pct_txt = $('#'+uid+' span[data-fileupload-area="pct"]');
				var progbar = $('#'+uid+' div[data-fileupload-area="progbar"]');
				var cancel = $('#'+uid+' i[data-fileupload-action="close"]');
				// Begin uploading
				var jqxhr = $.ajax({
					type:'POST',
					url:'/api/item/file/upload/',
					data:data,
					processData:false,
					contentType: false,
					dataType:'json',
					cache: false,
					xhr:function(){
						var xhr = new window.XMLHttpRequest();
						xhr.upload.addEventListener("progress", function(evt) {
							if (evt.lengthComputable) {
								var percentComplete = Math.round((evt.loaded / evt.total)*100);
								$(pct_txt).text(percentComplete+'%');
								$(progbar).css('width',percentComplete+'%');
							}
						}, false);
						return xhr;
					},
					success:function(result) {
						if (result.success) {
							$('span[data-fileupload-area="pct"]',upload_record).text('Done!');
							setTimeout(function(){
								upload_record.remove();
								my.removeUploadStatusContainerIfEmpty(function(is_done){
									cb_done(is_done);
								});
							},1000);
						}
						else {
							$('span[data-fileupload-area="pct"]',upload_record).text('Error!');
							setTimeout(function(){
								upload_record.remove();
								my.removeUploadStatusContainerIfEmpty(function(is_done){
									cb_done(is_done);
								});
							},1500);
						}
					}
				}).done(function(){});
				// Cancel button
				$(cancel).unbind('click').click(function(){
					jqxhr.abort();
					upload_record.remove();
					my.removeUploadStatusContainerIfEmpty(function(is_done){
						cb_done(is_done);
					});
				});
			});
		},
		addUploadStatus:function(file,uid,cb_ready){
			if ($('#uploadlist').length==0) {
				$('body').append('<ul id="uploadlist"></ul>');
			}
			// Create upload status record
			c = '<li class="file" id="'+uid+'">';
			c += '<div class="info">';
			c += '<span class="pct" data-fileupload-area="pct">1%</span><span class="filename">'+file.name.substring(0,50)+'</span>';
			c += '<i class="fa fa-times" data-fileupload-action="close"></i>';
			c += '</div>';
			c += '<div class="prog"><div class="bar" style="width:1%;" data-fileupload-area="progbar"></div></div>';
			c += '</li>';
			$('#uploadlist').append(c).ready(function(){
				cb_ready();
			});
		},
		removeUploadStatusContainerIfEmpty:function(cb){
			setTimeout(function(){
				if ($('#uploadlist>li').length==0) {
					$('#uploadlist').remove();
					cb(true);
				}
				else {
					cb(false);
				}
			},100);
		}
	}
	return my;
}());